module.exports = __webpack_public_path__ + "static/plant-wall-11cdae3ae698ec8d47ce1954cc436e0e.png";